import { Badge } from '@mantine/core';
import {
  HighwayMaintenanceFeeTicketState,
  HIGHWAY_MAINTENANCE_FEE_TICKET_STATE_POLICY,
} from '../model';

const STATE_BADGE_COLOR: Record<HighwayMaintenanceFeeTicketState, string> = {
  [HighwayMaintenanceFeeTicketState.PENDING]: 'yellow',
  [HighwayMaintenanceFeeTicketState.NO_FEE]: 'gray',
  [HighwayMaintenanceFeeTicketState.QUERY_FAILED]: 'red',
  [HighwayMaintenanceFeeTicketState.CHARGING]: 'blue',
  [HighwayMaintenanceFeeTicketState.CHARGE_FAILED]: 'orange',
  [HighwayMaintenanceFeeTicketState.CHARGE_SUCCESS]: 'green',
  [HighwayMaintenanceFeeTicketState.COMPLETED]: 'teal',
};

export const HighwayMaintenanceFeeStateBadge = ({
  state,
}: {
  state: HighwayMaintenanceFeeTicketState;
}) => (
  <Badge color={STATE_BADGE_COLOR[state]} variant="light" size="lg">
    {HIGHWAY_MAINTENANCE_FEE_TICKET_STATE_POLICY[state].text}
  </Badge>
);
